import { render, staticRenderFns } from "./RecoveryCodeView.vue?vue&type=template&id=bcb1852e&scoped=true&"
import script from "./RecoveryCodeView.vue?vue&type=script&lang=js&"
export * from "./RecoveryCodeView.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCodeView.vue?vue&type=style&index=0&id=bcb1852e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb1852e",
  null
  
)

export default component.exports